module.exports = __webpack_public_path__ + "img/project.497b07f3.svg";